import React, { useState } from "react"

interface ReferenceChangeModalProps {
  isOpen: boolean
  onClose: () => void
  brandId: string
  brandReference?: string
  onReferenceChange: (brandId: string, reference: string) => Promise<void>
}

const ReferenceChangeModal: React.FC<ReferenceChangeModalProps> = ({
  isOpen,
  onClose,
  brandId,
  brandReference,
  onReferenceChange,
}) => {
  const [reference, setReference] = useState(brandReference || "")
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      await onReferenceChange(brandId, reference)
      onClose()
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Referans güncelleme hatası:", error)
    } finally {
      setIsLoading(false)
    }
  }
  if (!isOpen) {
    return null
  }
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6 rounded-t-lg">
          <h2 className="text-xl font-semibold">Marka Referansı</h2>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Referans</label>
              <input
                type="text"
                value={reference}
                onChange={(e) => setReference(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Örn: google, facebook, email"
              />
            </div>
          </div>

          <div className="flex justify-end space-x-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              İptal
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
            >
              {isLoading ? "Güncelleniyor..." : "Güncelle"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ReferenceChangeModal
